import { Box, BoxProps, ColorOptions, Image, Loader } from '@jfs/ui-new'
import { Dimensions } from 'react-native'
import { EmptyView } from '../../../src/comps/EmptyView'
import { FormTitle } from '../../../src/comps/FormTitle'
import { PoweredByBanner } from '../../../src/comps/PoweredByBanner'

interface ContainerProps {
  children?: any
  isLoading?: any
  errorMessage?: string
  emptyMessage?: string
  onRetry?: any
  backgroundColor?: ColorOptions
  paddingTop?: number
  showFooter?: boolean
  paddingHorizontal?: number
  paddingBottom?: number
  type?: 'refund' | 'default'
  title?: string
  loadingMessage?: string
  showBrandLogo?: boolean
  overflow?: 'scroll' | 'hidden' | 'visible' | 'auto'
}

export const Container = ({
  children,
  isLoading,
  errorMessage,
  emptyMessage,
  onRetry,
  backgroundColor,
  paddingTop = 32,
  paddingBottom = 16,
  showFooter,
  paddingHorizontal = 16,
  type = 'default',
  title = '',
  loadingMessage,
  showBrandLogo,
  overflow,
}: ContainerProps) => {
  const shouldShowEmptyView = () => isLoading || errorMessage || emptyMessage
  return (
    <Box {...styles[type].container(backgroundColor ?? 'PRIMARY')}>
      <Box {...styles[type].innerContainer({ paddingTop, paddingBottom, paddingHorizontal, overflow })}>
        {title && <FormTitle title={title} />}
        {shouldShowEmptyView() && (
          <Box height={'100%'} flex={1} minHeight={type === 'refund' ? '30vh' : undefined} justifyContent={'center'}>
            <EmptyView
              onRetry={onRetry}
              isLoading={isLoading}
              loadingMessage={loadingMessage}
              loaderComponent={<Loader type="large" color="PRIMARY_STORNG" />}
              emptyMessage={emptyMessage}
              error={errorMessage && { networkError: { data: { errors: [{ details: errorMessage }] } } }}
            />
          </Box>
        )}
        {!shouldShowEmptyView() && children}
      </Box>
      {showBrandLogo && <BrandLogo />}
      {showFooter && <PoweredByBanner />}
    </Box>
  )
}

export const BrandLogo = () => {
  return (
    <Box backgroundColor={'WHITE'}>
      <Image
        source={require('../../assets/icons/ic_jpb_aeps_logo.png')}
        width={'100%'}
        height={48}
        resizeMode={'contain'}
      />
    </Box>
  )
}

const styles = {
  default: {
    container: (backgroundColor: ColorOptions) =>
      ({
        backgroundColor,
        f: 1,
      } as BoxProps),
    innerContainer: ({ paddingTop, paddingBottom, paddingHorizontal, overflow }: any) =>
      ({
        backgroundColor: 'WHITE',
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        ph: paddingHorizontal,
        paddingTop,
        paddingBottom,
        f: 1,
        overflow: overflow,
      } as BoxProps),
  },
  refund: {
    container: () =>
      ({
        flex: 1,
        backgroundColor: 'BACKGROUND_LIGHT',
        pt: 24,
        justifyContent: 'space-between',
      } as BoxProps),
    innerContainer: ({ paddingHorizontal, overflow }: any) =>
      ({
        underlayColor: 'WHITE',
        overflow: overflow || 'scroll',
        // overflow: 'scroll',
        bg: 'WHITE',
        ph: paddingHorizontal,
        pv: 24,
        marginHorizontal: 16,
        maxHeight: Dimensions.get('window').height - 120,
        backgroundColor: 'WHITE',
        borderWidth: 1,
        borderRadius: 8,
        borderTopWidth: 0,
        borderColor: '#e3e6f0' as ColorOptions,
      } as BoxProps),
  },
}
